import React from 'react'

export default function IcoChat( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M4 5h16v11H9l-4 3.5V16H4z" />
    </svg>
  )
}
